import { t } from "i18next";

import Trophy from "@/assets/icons/trophy.svg?react";
import { useStore } from "@/hooks/store";

import { overallStyles, top1000Styles } from "./styles";

export const Rating = () => {
  const { score } = useStore((state) => state.user.networksData[state.network]);
  if (!score) return null;

  if (score.top1000) {
    return (
      <top1000Styles.Container>
        <Trophy />
        <p>{t("Rating.CurrentRank")}</p>
        <p>#{score.top1000}</p>
      </top1000Styles.Container>
    );
  }

  if (score.rating) {
    return (
      <overallStyles.Container>
        <Trophy />
        <p>{t("Rating.BetterThan", { rating: score?.rating })}</p>
      </overallStyles.Container>
    );
  }

  return null;
};
